import { jsx as _jsx } from "react/jsx-runtime";
var SetSymbol = function (_a) {
    var set = _a.set, rarity = _a.rarity;
    var className = 'ss ss-' + set.toLowerCase() + ' ss-' + rarity.toLowerCase() + ' ss-grad ';
    return _jsx("i", { className: className, style: { fontSize: '150%' }, title: set }, void 0);
};
export default SetSymbol;
